import {
  Component,
  OnInit,
  EventEmitter,
  Output,
  Input,
  ChangeDetectorRef,
  ViewChild,
  ElementRef,
  ViewEncapsulation,
} from '@angular/core'
import { FormGroup, Validators, FormBuilder, FormControl } from '@angular/forms'
import { switchMap, take } from 'rxjs/operators'
import { Observable, of, Subscription } from 'rxjs'
import {
  ActiveCartFacade,
  MultiCartFacade,
  OrderEntry,
} from '@spartacus/cart/base/root'
import {
  User,
  AuthService,
  GlobalMessageService,
  GlobalMessageType,
} from '@spartacus/core'
import moment from 'moment'
import { QuoteCartService } from '../../quote-services/quote-cart.service'
import { formatDate, DatePipe } from '@angular/common'
import { UserAccountFacade } from '@spartacus/user/account/root'
import { SnackbarService } from '../../../../shared/directive/snackBar/snackbar.service'
import { CalenderConfigService } from '../../../../shared/services/calender-config.service'
import { BulkServiceService } from '../../../bulk-order/bulk-service.service'
import { QuoteCartFacade } from '../../../cart/mini-cart/store/mini-quote-cart.facade'

@Component({
  standalone: false,

  selector: 'vs-add-product',
  templateUrl: './add-product.component.html',
  styleUrls: ['./add-product.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class AddProductComponent implements OnInit {
  @Input() cartId
  @Input() loaded: boolean
  @Input() defaultRequestedDate: Date
  @Output() cancelAdding = new EventEmitter<string>()
  @Output() productAdding = new EventEmitter<string>()
  @Output() cancelAddingLoaded = new EventEmitter<string>()
  @ViewChild('partNumberInput') partNumberInput
  @ViewChild('partNumberList') partNumberList
  public view = false
  catalogue = true
  quantity = 1
  populated = false
  partDescription: any
  submitted = false
  minDate = new Date()
  catalogProductSelected = false
  user$: Observable<User>
  public LoggedIn: boolean
  public selected: boolean = false
  userType: string
  partNum: any
  loggedIn: boolean
  quoteForm: FormGroup
  public reasonForQuote
  public cartStatus
  products
  showSearchLoader = false
  defDate: Date = new Date()
  actualDateFormGroup = ''
  brandList: Object
  productTypeName: any
  isShowForm = false
  public reasonForQuoteArray$: Observable<any>
  productsListAvailable: boolean = true
  showAddProductLoader = false
  PART_PLACEHOLDER = 'part_placeholder'
  filterWeekend = this.calenderConfigService.isFilterWeekend()
  PARTS_PLACEHOLDER = 'parts_placeholder'
  part_error: boolean = false
  isEnter: boolean = false
  private ignoreCloseEvent = false
  newQuoteIdGenrate: Subscription
  uom: string = 'each'
  constructor(
    private formBuilder: FormBuilder,
    private quoteService: QuoteCartService,
    private auth: AuthService,
    private multiCartService: MultiCartFacade,
    protected cartService: ActiveCartFacade,
    private cdRef: ChangeDetectorRef,
    public datepipe: DatePipe,
    private el: ElementRef,
    public globalMessageService: GlobalMessageService,
    private calenderConfigService: CalenderConfigService,
    private bulkService: BulkServiceService,
    private userAccountFacade: UserAccountFacade,
    private quoteCartFacade: QuoteCartFacade
  ) {
    document.addEventListener('click', this.bodyClick.bind(this))
    this.user$ = this.auth.isUserLoggedIn().pipe(
      switchMap((isUserLoggedIn) => {
        if (isUserLoggedIn) {
          this.userType = 'current'
          this.cartStatus = sessionStorage.getItem('cartStatus-current')
          this.cartId = sessionStorage.getItem('cartId-current')
          return this.userAccountFacade.get()
        } else {
          this.userType = 'anonymous'
          this.cartStatus = sessionStorage.getItem('cartStatus-anonymous')
          this.cartId = sessionStorage.getItem('cartId-anonymous')
          return of(undefined)
        }
      })
    )
    this.auth.isUserLoggedIn().subscribe(
      (success) => {
        if (success) {
          this.userType = 'current'
          this.cartId = sessionStorage.getItem('cartId-current')
          this.cartStatus = sessionStorage.getItem('cartStatus-current')
        } else {
          this.userType = 'anonymous'
          this.cartId = sessionStorage.getItem('cartId-anonymous')
          this.cartStatus = sessionStorage.getItem('cartStatus-anonymous')
        }
      },
      (error) => {
        this.globalMessageService.add(
          error,
          GlobalMessageType.MSG_TYPE_ERROR,
          5000
        )
        window.scrollTo(0, 0)
      }
    )
  }
  ngOnInit(): void {
    this.reasonForQuoteArray$ = this.quoteService.getQuoteReason(this.userType)
    this.reasonForQuoteArray$.subscribe(
      (res) => {
        this.reasonForQuote = res.reasonforQuote
        // if(this.reasonForQuote[0]){
        //   this.reasonForQuote[0].selected = true;
        // }
      },
      (error) => {
        this.globalMessageService.add(
          error,
          GlobalMessageType.MSG_TYPE_ERROR,
          5000
        )
        window.scrollTo(0, 0)
      }
    )
    this.newQuoteIdGenrate = this.bulkService.newQuoteId.subscribe(
      (newQuoteId) => {
        if (newQuoteId) {
          this.addProduct()
        }
      }
    )
    this.quoteForm = this.formBuilder.group({
      partNumber: ['', Validators.required],
      productType: ['', Validators.required],
      serialNumber: new FormControl(),
      partDescription: ['', Validators.required],
      brand: [null, Validators.required],
      tagNumber: new FormControl(),
      quantity: [1, Validators.required],
      // customerRequestedDate: ['', Validators.required],
      reasonforQuote: new FormControl(),
      comment: new FormControl(),
    })
    this.productTypeName = this.quoteForm.value.productType
    this.quoteForm.controls['productType'].valueChanges.subscribe((data) => {
      this.productTypeName = data
      if (this.productTypeName == 'part') {
        this.quoteForm.controls['serialNumber'].setValidators([
          Validators.required,
        ])
      } else if (this.productTypeName == 'equipment') {
        this.quoteForm.controls['serialNumber'].clearValidators()
        this.quoteForm.controls['serialNumber'].setValue('')
      } else {
        this.quoteForm.controls['serialNumber'].clearValidators()
      }
      this.quoteForm.controls['serialNumber'].updateValueAndValidity()
    })
    let appliedDate
    if (sessionStorage.getItem('quoteCart') != undefined) {
      appliedDate = sessionStorage.getItem('quoteCart')
    } else {
      appliedDate = sessionStorage.getItem('quoteCart-requestedDate')
    }
    if (appliedDate && this.loaded) {
      const nextDate = new Date(appliedDate)
      // nextDate.setDate(nextDate.getDate() + 1);
      const defDate = this.datepipe.transform(nextDate, 'yyyy-MM-dd')
      // const defDate = nextDate.toISOString().split('T')[0];
      let paramDate = defDate.split('-')
      let newDate =
        paramDate[0] + '/' + paramDate[1] + '/' + parseInt(paramDate[2])
      // this.quoteForm.controls.customerRequestedDate.setValue(newDate);
    }

    if (!this.loaded) {
      sessionStorage.setItem('quoteCart-requestedDate', '')
    }
    this.getBrands()
  }

  get productType() {
    return this.quoteForm.get('productType').value || 'part '
  }
  getBrands() {
    this.quoteService.getBrand(this.userType, this.cartId).subscribe(
      (success) => {
        this.brandList = success
      },
      (error) => {
        this.globalMessageService.add(
          error,
          GlobalMessageType.MSG_TYPE_ERROR,
          5000
        )
        window.scrollTo(0, 0)
      }
    )
  }
  dateChange(event) {
    var newData = event
      .toISOString()
      .slice(0, 19)
      .replace(/-/g, '/')
      .split('T')[0]
    let paramDate = newData.split('/')
    let newDate = moment(event).format('YYYY/MM/DD')

    this.quoteForm.controls['customerRequestedDate'].setValue(newDate)
  }
  populateFields(product) {
    this.uom = product.salesUnit
    this.products = []
    this.catalogProductSelected = true
    this.isShowForm = true
    this.view = false
    this.disableClose()
    this.quoteForm.controls['partNumber'].setValue(product?.code)
    this.quoteForm.controls['partDescription'].setValue(
      product?.description?.substring(0, 40)
    )
    this.quoteForm.controls['serialNumber'].setValue(
      product?.serialNumber?.substring(0, 200)
    )
    this.partDescription = product.name
    this.quoteForm.controls['productType'].setValue(product?.productType)
    this.catalogue = true
    this.populated = true
    this.quoteForm.controls['partNumber'].disable()
    this.quoteForm.controls['partDescription'].disable()
    if (product.productLine) {
      this.quoteForm.controls['brand'].setValue(product.productLine)
      this.quoteForm.controls['brand'].disable()
    }
    this.quoteForm.controls['comment'].setValue('')
    let appliedDate
    if (sessionStorage.getItem('quoteCart') != undefined) {
      appliedDate = sessionStorage.getItem('quoteCart')
    } else {
      appliedDate = sessionStorage.getItem('quoteCart-requestedDate')
    }
    if (appliedDate && this.loaded) {
      const nextDate = new Date(appliedDate)
      // nextDate.setDate(nextDate.getDate() + 1);
      const defDate = this.datepipe.transform(nextDate, 'yyyy-MM-dd')
      let paramDate = defDate.split('-')
      let newDate =
        paramDate[0] + '/' + paramDate[1] + '/' + parseInt(paramDate[2])

      // this.quoteForm.controls.customerRequestedDate.setValue(newDate);
    }

    this.quoteForm.controls['quantity'].setValue('1')
    this.quoteForm.controls['reasonforQuote'].setValue(
      this.reasonForQuote[0].code
    )
    this.quoteForm.controls['serialNumber'].setValue('')
    this.quoteForm.controls['tagNumber'].setValue('')
  }

  get f() {
    return this.quoteForm.controls
  }

  addProduct() {
    this.submitted = true
    if (this.quoteForm.invalid) {
      this.errorFocus()
      return
    }
    const submitObj = {
      brandName: this.quoteForm.controls['brand'].value || 'MASONEILAN',
      brandCode: this.quoteForm.controls['brand'].value || 'MASONEILAN',
      comment: this.quoteForm.controls['comment'].value,
      customerRequestedDate: '',
      // customerRequestedDate: this.quoteForm.controls.customerRequestedDate.value,
      // .toISOString()
      // .slice(0, 19)
      // .replace(/-/g, '/')
      // .split('T')[0],
      rfqPartDescription:
        this.quoteForm.controls['partDescription'].value ||
        this.quoteForm.controls['partNumber'].value,
      rfqPartNumber: this.quoteForm.controls['partNumber'].value,
      productType: this.quoteForm.controls['productType'].value || 'part',
      quantity: this.quoteForm.controls['quantity'].value,
      reasonForQuote: this.quoteForm.controls['reasonforQuote'].value,
      serialNumber: this.quoteForm.controls['serialNumber'].value,
      tagNumber: this.quoteForm.controls['tagNumber'].value,
    }

    this.showAddProductLoader = true
    this.quoteService
      .getCart(this.cartId, this.userType)
      .subscribe((success) => {
        this.cartId = success['code']
      })
    this.quoteService
      .addProduct(this.userType, this.cartId, submitObj)
      .subscribe(
        (success) => {
          this.bulkService.newQuoteId.next(false)
          this.showAddProductLoader = false
          this.productTypeName = ''
          this.quoteForm.reset()
          this.cartStatus = 'added'
          if (this.userType === 'current') {
            sessionStorage.setItem('cartStatus-current', this.cartStatus)
          }
          if (this.userType === 'anonymous') {
            sessionStorage.setItem('cartStatus-anonymous', this.cartStatus)
          }
          // this.snackbar.open('Product(s) added to Quote Cart');
          this.productAdding.emit('added')
          this.quoteCartFacade.loadCart();          
        },
        (error) => {
          this.showAddProductLoader = false
          this.globalMessageService.add(
            { key: 'quoteCart.errorAddingProductQuoteCart' },
            GlobalMessageType.MSG_TYPE_ERROR,
            5000
          )
          this.showAddProductLoader = false
          this.globalMessageService.remove(GlobalMessageType.MSG_TYPE_ERROR)
          this.bulkService.newQuoteId.next(false)
          window.scrollTo(0, 0)
        }
      )
  }
  disableClose(): void {
    this.ignoreCloseEvent = true
  }
  close(event: UIEvent): void {
    this.view = true

    if (!this.ignoreCloseEvent && this.partNum?.length > 2) {
      this.filterRecords()
    }
  }
  filterRecords() {
    let result = this.products.filter(
      (item) => item.code.toLowerCase() == this.partNum.toLowerCase()
    )
    if (result.length === 0) {
      this.isEnter = true
      this.showSearchLoader = false
      this.isShowForm = true
      this.view = false
      this.catalogue = false
      this.populated = true
      this.productsListAvailable = false
      // this.quoteForm.controls.reasonforQuote.setValue(
      //   this.reasonForQuote[0].code
      // );
      this.quoteForm.controls['partNumber'].disable()
    }
  }
  searchProducts(event, isEnter) {
    this.part_error = false
    this.populated = false
    this.productsListAvailable = false
    this.partNum = this.quoteForm.get('partNumber').value
    this.view = false
    this.catalogue = false
    this.isShowForm = false
    this.isEnter = false
    this.ignoreCloseEvent = false
    // this.populated = false;
    if (
      this.partNum.toLowerCase().indexOf(this.PART_PLACEHOLDER) != -1 ||
      this.partNum.toLowerCase().indexOf(this.PARTS_PLACEHOLDER) != -1
    ) {
      this.part_error = true
      return
    }
    this.products = []
    if (this.partNum.length > 2) {
      this.showSearchLoader = true
      this.quoteService.searchProduct(this.partNum).subscribe(
        (success: any) => {
          this.products = success.products
          this.showSearchLoader = false
          this.productsListAvailable = false
          if (this.products.length === 0) {
            this.isEnter = isEnter
            this.showSearchLoader = false
            this.isShowForm = true
            this.view = false
            this.catalogue = false
            this.populated = true
            this.productTypeName = this.quoteForm.controls['productType'].value
            this.productsListAvailable = false
            this.quoteForm.controls['reasonforQuote'].setValue(
              this.reasonForQuote[0].code
            )
          }
          if (this.products.length > 0 && !isEnter) {
            this.isEnter = isEnter
            this.productTypeName = success.products[0].productType
            this.view = true
            this.catalogue = true
            this.populated = true
            this.productsListAvailable = true
          }
          if (this.products.length > 0 && isEnter) {
            this.view = true
            this.filterRecords()
          }
          this.cdRef.detectChanges()
        },
        (error) => {
          this.globalMessageService.add(
            error,
            GlobalMessageType.MSG_TYPE_ERROR,
            5000
          )
          window.scrollTo(0, 0)
        }
      )
    }
  }
  ngOnDestroy() {
    if (this.newQuoteIdGenrate) {
      this.newQuoteIdGenrate.unsubscribe()
    }
  }
  cancel() {
    if (this.loaded) {
      this.populated = false
      this.clearForm()
      this.partNumberInput.nativeElement.focus()
      // this.cancelAddingLoaded.emit('cancel');
      return
    } else {
      this.populated = false
      this.clearForm()
      this.partNumberInput.nativeElement.focus()
    }
    this.cancelAdding.emit(this.cartStatus)
  }

  clearForm() {
    // this.catalogue = false;
    this.products = []
    this.isEnter = false
    this.disableClose()
    this.catalogProductSelected = false
    this.submitted = false
    this.isShowForm = false

    this.partDescription = ''
    this.quoteForm.controls['partNumber'].enable()
    this.quoteForm.controls['brand'].enable()
    this.quoteForm.controls['partDescription'].enable()

    this.quoteForm.controls['brand'].setValue('')
    this.quoteForm.controls['partDescription'].setValue('')
    this.quoteForm.controls['partNumber'].setValue('')
    this.quoteForm.controls['comment'].setValue('')
    // this.quoteForm.controls.customerRequestedDate.setValue('');
    this.quoteForm.controls['productType'].setValue('')
    this.quoteForm.controls['quantity'].setValue('1')
    this.quoteForm.controls['reasonforQuote'].setValue(
      this.reasonForQuote[0].code
    )
    this.quoteForm.controls['serialNumber'].setValue('')
    this.quoteForm.controls['tagNumber'].setValue('')
  }

  getSuggestionTooltip(product) {
    return product.code + ' | ' + this.parseHtmlText(product.description)
  }

  getProductImage(product) {
    const media = {
      format: 'thumbnail',
      imageType: 'PRIMARY',
      url: product.firstVariantImage,
    }
    return media
  }

  parseHtmlText(htmlText) {
    const dom = new DOMParser().parseFromString(
      '<!doctype html><body>' + htmlText,
      'text/html'
    )
    const decodedString = dom.body.textContent
    return decodedString
  }

  getPartDescTooltip(tooltipText) {
    if (tooltipText) {
      return this.parseHtmlText(tooltipText)
    }
    return ''
  }

  bodyClick() {
    this.catalogue = false
    if (
      this.partNumberInput &&
      !this.partNumberInput.nativeElement.contains(event.target) &&
      this.partNumberList &&
      !this.partNumberList.nativeElement.contains(event.target)
    ) {
      this.view = false
      this.cdRef.detectChanges()
    }
  }

  errorFocus() {
    for (const key of Object.keys(this.quoteForm.controls)) {
      if (this.quoteForm.controls[key].invalid) {
        const invalidControl = this.el.nativeElement.querySelector(
          '[formcontrolname="' + key + '"]'
        )
        if (
          invalidControl.type === 'radio' ||
          invalidControl.type === 'checkbox'
        ) {
          invalidControl.parentElement.scrollIntoView({
            behavior: 'smooth',
            block: 'center',
          })
          break
        }
        invalidControl.focus()
        break
      }
    }
  }
}
